<template>
    <input type="text"
           :name="name"
           :id="id"
           :placeholder="placeholder"
           readonly>
</template>

<script>
    import moment from 'moment';
    import '../../../../../../node_modules/pickadate/lib/legacy.js'
    import '../../../../../../node_modules/pickadate/lib/picker.js'
    import '../../../../../../node_modules/pickadate/lib/picker.time.js'

    export default {
        name: 'VueTimePicker',
        model: {
            prop: 'selectedTime',
            event: 'change'
        },
        props: {
            id: {
                type: String,
                required: true
            },
            selectedTime: {
                type: String,
                default: ''
            },        
            name: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        mounted() {
            var getTimeFormatted = function(time) {
                var hours = time.hour;
                    if(hours < 10)
                        hours = "0" + hours;

                    var mins = time.mins;
                    if (mins < 10) {
                        mins = "0" + mins;  //handle 13:05 && 13:00 -> we receive as 13:5 or 13:0
                    }
                    var suffix = hours >= 12 ? "pm" : "!am"; 
                    return hours + ":" + mins + " " + suffix;
            };
            
            var currentTime = "";
            $(this.$el).pickatime({
                interval: 5,
                format: 'HH:i',
                //format: 'HH:i a',
                //formatLabel: function (time) {
                //    return getTimeFormatted(time);
                //},
                onSet: (context) => {
                    var value = this.getPickerValue();
                    if (!value) return;

                    var newValue = getTimeFormatted(value);
                    if(newValue == currentTime) return;
                   
                    currentTime = newValue;

                    this.onDateSelected(value.hour + ":" + value.mins);
                }
            });


            this.picker = $(this.$el).pickatime('picker');
            this.setPickerValue();
        },
        watch: {
            selectedTime: function (newVal, oldVal) {
                var oldVal = this.getPickerValue();
                if (oldVal)
                    oldVal = oldVal.hour + ":" + oldVal.mins;

                if (newVal !== oldVal) {
                    this.setPickerValue();    
                }
            }
        },
        methods: {
            getPickerValue: function () {
                var value = this.picker.get('select');
                if (!value) return null;

                if (value.mins < 10) {
                    value.mins = "0" + value.mins;  //handle 13:05 && 13:00 -> we receive as 13:5 or 13:0
                }
                if (value.hour < 10)
                    value.hour = "0" + value.hour;

                return value;
            },
            setPickerValue: function () {
                if (this.selectedTime) {
                    this.picker.set('select', this.selectedTime);
                }
                else {
                    this.picker.set('clear');
                }
            },
            onDateSelected(newValue) {
                console.log(newValue);
                //this.selectedTime = newValue;
                this.$emit("change", newValue);
            }
        }
    }
</script>